
import React, { useState, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpIcon from '@mui/icons-material/Help';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import CallIcon from '@mui/icons-material/Call';
import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded';
import Modal from "@mui/material/Modal";
import UpdateIcon from '@mui/icons-material/Update';
import ClearIcon from '@mui/icons-material/Clear';
import AdjustIcon from '@mui/icons-material/Adjust';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import "./style/TicketHistoryTimeline.css";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "3px solid green",
      borderRadius: "5px",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: "1400px",
      height: "750px",
      overflow: 'scroll',
    },
    paper1: {
      backgroundColor: theme.palette.background.paper,
      border: "3px solid green",
      borderRadius: "5px",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: "550px",
      height: "200",
      overflow: 'scroll',
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

interface Props {
  openTicketHistoryModel: any;
  setOpenTicketHistoryModel: Function;
  ticketTimeline: any;
  loading: any;
  bookingId: any;
}

const TicketTimeLine: React.FC<Props> = ({
  openTicketHistoryModel,
  setOpenTicketHistoryModel,
  ticketTimeline,
  loading,
  bookingId
}) => {
  const classes = useStyles();
  const [leftContainer, setLeftContainer] = useState([]);
  const [expendMore, setExpendMore] = useState<any>(false);
  const [lastReply, setLastReply] = useState<any>("");
  const [commentData, setCommentData] = useState<any>("");
  const [PhaRemarks, setPhaRemarks] = useState<any>("");
  const [rmRemarks, setRmRemarks] = useState<any>("");
  const [labRemarks, setLabRemarks] = useState<any>("");
  const [userGroup, setUserGroup] = useState<any>("");
  const [timeLineData, setTimeLineData] = useState({
    id: "",
    status: "",
    disposition_name: "",
    cx_name: "",
    created_At: "",
    updated_At: "",
    rm_remarks: "",
    pha_remarks: "",
    lab_remarks: "",
    query: "",
    comment: [],
    totalAttempts: "",
    action_status: "",
    booking_dispositions: [],
  });

  const handleClose = () => {
    setOpenTicketHistoryModel(false)
    setLeftContainer([])
    setTimeLineData({
      id: "",
      status: "",
      disposition_name: "",
      cx_name: "",
      created_At: "",
      updated_At: "",
      rm_remarks: "",
      pha_remarks: "",
      lab_remarks: "",
      query: "",
      comment: [],
      totalAttempts: "",
      action_status: "",
      booking_dispositions: [],
    });
  };

  const handleSpecificData = (ticketId: any, status: any, disposition: any, cxName: any, created_at: any, lab_remarks: any, query: any, comments: any, updated_at: any, totalAttempts: any, action_status: any, booking_dispositions: any) => {
    setTimeLineData({
      id: ticketId,
      status: status,
      disposition_name: disposition,
      cx_name: cxName,
      created_At: created_at,
      updated_At: updated_at,
      rm_remarks: lab_remarks,
      pha_remarks: lab_remarks,
      lab_remarks: lab_remarks,
      query: query,
      comment: comments,
      totalAttempts: totalAttempts,
      action_status: action_status,
      booking_dispositions: booking_dispositions
    });
  };

  useEffect(() => {
    if (ticketTimeline?.count > 0) {
      setLeftContainer(ticketTimeline?.results);
    }
  }, [ticketTimeline]);

  useEffect(() => {
    setCommentData(timeLineData?.comment);
  }, [timeLineData]);

  useEffect(() => {
    setUserGroup(commentData && commentData[0] && commentData[0]?.user_group);
    setLastReply(commentData && commentData[0] && commentData[0]?.comments);
    if (userGroup === "PhleboAdmin") {
      setPhaRemarks(commentData && commentData[0] && commentData[0]?.comments);
    }
    if (userGroup === "RouteManager") {
      setRmRemarks(commentData && commentData[0] && commentData[0]?.comments)
    }
    if (userGroup === "SampleAccessioning") {
      setLabRemarks(commentData && commentData[0] && commentData[0]?.comments)
    }
  }, [commentData])

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openTicketHistoryModel}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={openTicketHistoryModel}>

        <div >
          {ticketTimeline && ticketTimeline.results && ticketTimeline?.results?.length > 0 ? (
            <>
              <div className={classes.paper}>


                <span className="mainPara">
                  Ticket Timeline,
                  Booking Id:{bookingId}
                </span>
                <span className="closeIcons">
                  <ClearIcon
                    onClick={handleClose}
                  /></span>



                <div className="tabs">
                  <div id="myDiv" className="timeLineCallNames"
                  >
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                       <p>Loading...</p>
                      </div>
                    ) : leftContainer?.length > 0 ? (
                      leftContainer.map((row: any) => (
                        <div
                          className="ticketTimeLineSingle"
                          style={
                            row?.status === "pending"
                              ? { backgroundColor: "#fce4ec" }
                              : { backgroundColor: "#e0f2f1" }
                          }
                          onClick={() =>
                            handleSpecificData(row?.id, row?.status, row?.disposition_name, row?.booking?.customer_name, row.created_at, row.receicer_remarks, row.query, row.comments, row?.updated_at, row.total_attempts,
                              row?.action_status, row.booking_dispositions)
                          }
                        >
                          <div className="whatsAppCallNamesNumber" id="hr">
                            <p className="tabsParagraph">
                              {row?.disposition_name}
                            </p>
                            <p className="tabsParagraph">
                              Ticket Id :{row.id}

                            </p>
                            <span className="notbold">
                              Created At: {row?.created_at.substring(0, 10)}{" "}
                              {row?.created_at.substring(11, 19)}{" "}
                            </span>
                          </div>
                          <div>

                          </div>
                        </div>
                      ))
                    ) : (
                      "NA"
                    )}
                  </div>
                </div>
                <div className="tabcontents">
                  {timeLineData?.id ? (
                    <>
                      <div className="tabcontentsHeader">
                        <span style={{ fontWeight: "normal" }} >
                          Cx Name : <span>{timeLineData?.cx_name}</span>
                        </span>
                        <span style={{ fontWeight: "normal" }}>
                          Ticket Id : <span>{timeLineData?.id}</span>
                        </span>
                        <span style={{ fontWeight: "normal" }} >
                          Ticket Type : <span>{timeLineData?.disposition_name}</span>
                        </span>
                        <span style={{ fontWeight: "normal" }} >
                          Status : <span>{timeLineData?.action_status}</span>
                        </span>
                      </div>
                      <div className="tabcontentsbody1">
                        <p className="tabcontentsPara">
                          <AccessTimeIcon className="Icons1" />Created At :
                          <span style={{ fontWeight: "normal" }}>{timeLineData?.created_At.substring(0, 10)}{" "}
                            {timeLineData?.created_At.substring(11, 19)}
                          </span>
                        </p>
                        <p className="tabcontentsPara"><UpdateIcon className="Icons1" />Last Update: <span style={{ fontWeight: "normal" }}>{timeLineData?.updated_At.substring(0, 10)}{" "}
                          {timeLineData?.updated_At.substring(11, 19)}
                        </span> </p>
                        <p className="tabcontentsPara">
                          <HelpIcon className="Icons1" />
                          Initial query : <span style={{ fontWeight: "normal" }}>{timeLineData?.query}</span></p>
                        <p className="tabcontentsPara"><InsertCommentIcon className="Icons1" />Last Reply :<span style={{ fontWeight: "normal" }}>{lastReply?.replace("_", " ")?.toUpperCase()}</span></p>
                        <hr />
                      </div>

                      <div className="tabcontentsbody2">
                        <p className="tabcontentsPara">
                          <GraphicEqRoundedIcon className="Icons2" />Ticket Time Disposed :{timeLineData?.comment?.length}

                          <CallIcon className="Icons2" />CS Call Attempts :{timeLineData?.booking_dispositions?.length }

                          <span>
                            {
                              expendMore ?
                                <ExpandLessIcon
                                  className="Icons2"
                                  onClick={() => setExpendMore(false)}
                                />
                                :
                                <ExpandMoreIcon
                                  className="Icons2"
                                  onClick={() => setExpendMore(!expendMore)}
                                />
                            }
                          </span>
                        </p>
                        {expendMore === true ? (
                          <>
                            {timeLineData && timeLineData?.comment && timeLineData?.comment?.length > 0 && timeLineData?.comment?.map((repeatedComment: any) => {
                              return (
                                <>
                                  <p className="tabcontentsPara"><GraphicEqRoundedIcon className="Icons2" />
                                    <span>
                                      {repeatedComment?.created_at?.substring(0, 10)}{" "}
                                      {repeatedComment?.created_at?.substring(11, 19)}
                                    </span> {" "}{" "}|{" "}{" "}
                                    <span style={{ fontWeight: "normal" }}>
                                      {repeatedComment.panel_user}
                                    </span>
                                    <p>
                                      <span style={{ marginLeft: "47px", fontWeight: "normal" }}>Dis:<span>{repeatedComment.disposition}</span> </span>  |
                                      <span style={{ fontWeight: "normal" }} >Sub: <span> {repeatedComment.action}</span></span>
                                    </p>
                                    <p style={{ marginLeft: "47px", fontWeight: "normal" }}>Remarks : <span >{repeatedComment.comments}</span></p>
                                  </p>

                                </>
                              )
                            })}
                            {timeLineData && timeLineData?.booking_dispositions && timeLineData.booking_dispositions?.length > 0 && timeLineData.booking_dispositions?.map((repeatedDisposition: any) => {

                              return (
                                <>
                                  <p className="tabcontentsPara"><CallIcon className="Icons2" />
                                    <span>
                                      {repeatedDisposition?.created_at?.substring(0, 10)}{" "}
                                      {repeatedDisposition?.created_at?.substring(11, 19)}
                                    </span> {" "}{" "}|{" "}{" "}
                                    <span style={{ fontWeight: "normal" }}>
                                      {repeatedDisposition?.by_user}
                                    </span>
                                    <p>
                                      <span style={{ marginLeft: "47px", fontWeight: "normal" }}>Dis:<span>{repeatedDisposition?.disposition}</span> </span>  
                                      {/* |
                                      <span style={{ fontWeight: "normal" }} >Sub: <span> {repeatedDisposition?.action}</span></span> */}
                                    </p>
                                    <p style={{ marginLeft: "47px", fontWeight: "normal" }}>Remarks : <span >{repeatedDisposition?.details}</span></p>
                                  </p>
                                </>
                              )

                            })}
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <ExpandLessIcon
                                className="Icons2"
                                onClick={() => setExpendMore(false)}
                              />
                            </span>

                          </>
                        ) : ""}

                        <hr />
                      </div>

                      <div className="tabcontentsbody3">
                        <p className="tabcontentsPara"><AdjustIcon className="Icons3" />Pha Remarks :  <span style={{ fontWeight: "normal" }}>{PhaRemarks}</span> </p>
                        <p className="tabcontentsPara"><AdjustIcon className="Icons3" />Rm Remarks :  <span style={{ fontWeight: "normal" }}>{rmRemarks}</span> </p>
                        <p className="tabcontentsPara"><AdjustIcon className="Icons3" />Lab Remarks :  <span style={{ fontWeight: "normal" }}>{labRemarks}</span> </p>
                      </div>
                    </>
                  ) : ""}

                </div>

              </div>
            </>
          ) :
            <>
              <div className={classes.paper1}>
                <p className="ExtraPara"
                  style={{ color: "red" }}>
                  No tickets available for this booking yet.
                </p>
              </div>
            </>
          }
        </div>
      </Fade>
    </Modal >
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.loginReducer.loading
});

export default connect(mapStateToProps, {

})(TicketTimeLine);